<script setup lang="ts">
import { useRoute } from "vue-router";
import AlertComponent from "@/components/Layout/AlertComponent.vue";
import HeaderBar from "@/components/Layout/HeaderBar.vue";
import FooterBar from "./FooterBar.vue";

const route = useRoute();
</script>

<template>
    <v-app>
        <HeaderBar></HeaderBar>
        <v-main>
            <v-container :class="route.name">
                <div class="content">
                    <AlertComponent id="default"></AlertComponent>
                </div>
                <RouterView></RouterView>
            </v-container>
        </v-main>
        <FooterBar></FooterBar>
    </v-app>
</template>

<style lang="scss" scoped>
.content {
    height: fit-content;
}

.v-main {
    background-color: #f5f2f1;
}

.v-container.your-basket,
.v-container.home {
    padding: 0;
}

.v-container.login {
    padding: 0;
    margin: 0;
    max-width: 100% !important;
}

/* Overrides to make specific pages wider */
@media (min-width: 1280px) {
    .v-container.searchresults {
        max-width: 95%;
    }
}

@media (min-width: 960px) {
    .v-container.searchresults {
        max-width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
    .v-container.your-basket {
        max-width: 100%;
    }
}

@media (max-width: 960px) {
    .v-container.your-basket {
        max-width: 100%;
    }
}

@media (max-width: 600px) {
    .v-container.register {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
